// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__27Q54","productName":"Table_productName__2qBgd"};